import theme from '@/theme';
import { primitiveColors, MAX_WIDTH_LG, MAX_WIDTH_MD, MAX_WIDTH_SM } from '@/theme/tokens';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { VotemateLogo } from './votemate-logo/VotemateLogo';
import { Link, useSearchParams } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

const SUPPORT_EMAIL = 'support@votemateus.org';

export const LoginError = () => {
  const { t } = useTranslation('auth');
  const [searchParams] = useSearchParams();

  const error = searchParams.get('error');
  const errorDescription = searchParams.get('error_description');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
        backgroundColor: primitiveColors.blue1,
        fontFamily: theme.typography.fontFamily,
      }}
    >
      <Box
        sx={{
          maxWidth: {
            sm: MAX_WIDTH_SM,
            md: MAX_WIDTH_MD,
            lg: MAX_WIDTH_LG,
          },
          padding: 3,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <VotemateLogo size={48} sx={{ justifyContent: 'center' }} />
        </Box>
        <Typography variant="h6" sx={{ mt: 2, color: primitiveColors.black }}>
          <Trans
            i18nKey="loginErrorBody"
            ns="auth"
            values={{ email: SUPPORT_EMAIL }}
            components={{
              loginLink: <Link to="/" />,
              supportLink: <a href={`mailto:${SUPPORT_EMAIL}`} />,
            }}
          />
        </Typography>
        <Alert severity="error" sx={{ mt: 2 }}>
          <Accordion
            sx={{
              backgroundColor: 'inherit',
              boxShadow: 'none',
              '& .MuiAccordionSummary-content': { margin: 0, '&.Mui-expanded': { margin: 0 } },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{ minHeight: '0 !important', '&.Mui-expanded': { margin: 0 } }}
            >
              <Typography>{t('loginErrorTechnicalDetails')}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pb: 0 }}>
              <Typography sx={{ textAlign: 'left' }}>
                {error && (
                  <>
                    <strong>{t('loginErrorErrorLabel')}</strong> {error}
                    <br />
                  </>
                )}
                {errorDescription && (
                  <>
                    <strong>{t('loginErrorDescriptionLabel')}</strong> {errorDescription}
                  </>
                )}
                {!error && !errorDescription && <>{t('loginErrorNoDetails')}</>}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Alert>
      </Box>
    </Box>
  );
};
